// extracted by mini-css-extract-plugin
module.exports = {"container":"_35qbyHHzIDl_MKMDJGYlc2","icon":"_2FMh64VeuB7Ub1704VoN8B"};